import { extractAri } from '@atlaskit/link-extractors';
export var extractViewRelatedLinksAction = function extractViewRelatedLinksAction(response) {
  var _response$meta;
  if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && (_response$meta = _response$meta.supportedFeature) !== null && _response$meta !== void 0 && _response$meta.includes('RelatedLinks'))) {
    return;
  }
  var ari = extractAri(response.data);
  if (!ari) {
    return;
  }
  return {
    ari: ari
  };
};